import React from 'react';
import { Utensils, Dumbbell, Moon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-[#F5F0E8]" data-id="element-146">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-147">
        <div className="text-center mb-16" data-id="element-148">
          <h2 className="text-3xl lg:text-5xl font-serif font-bold text-[#3D4852] mb-6" data-id="element-149">
            El Triángulo 21D: Tu Sistema de 3 Palancas
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-150">
            No es una receta milagro. Son 3 palancas que{' '}
            <span className="font-bold text-[#C17F6B]" data-id="element-151">SÍ</span> puedes
            controlar para recuperar tu cuerpo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-152">
          {/* Connecting lines for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-[#C17F6B]/20 -z-10 transform -translate-y-1/2" data-id="element-153"></div>

          {/* Pillar 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-b-4 border-[#C17F6B] relative z-10" data-id="element-154">
            <div className="w-16 h-16 bg-[#C17F6B]/10 rounded-full flex items-center justify-center mb-6 mx-auto text-[#C17F6B]" data-id="element-155">
              <Utensils className="w-8 h-8" data-id="element-156" />
            </div>
            <h3 className="text-xl font-bold text-[#3D4852] text-center mb-3" data-id="element-157">
              1. Proteína Primero
            </h3>
            <p className="text-gray-600 text-center" data-id="element-158">
              Saciedad real + protección muscular. La clave para dejar de picar
              entre horas.
            </p>
          </div>

          {/* Pillar 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-b-4 border-[#8B9A7D] relative z-10" data-id="element-159">
            <div className="w-16 h-16 bg-[#8B9A7D]/10 rounded-full flex items-center justify-center mb-6 mx-auto text-[#8B9A7D]" data-id="element-160">
              <Dumbbell className="w-8 h-8" data-id="element-161" />
            </div>
            <h3 className="text-xl font-bold text-[#3D4852] text-center mb-3" data-id="element-162">
              2. Fuerza Mínima Efectiva
            </h3>
            <p className="text-gray-600 text-center" data-id="element-163">
              15-20 min, 3x/semana. Tu cuerpo se aprieta y tu metabolismo
              despierta.
            </p>
          </div>

          {/* Pillar 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-b-4 border-[#3D4852] relative z-10" data-id="element-164">
            <div className="w-16 h-16 bg-[#3D4852]/10 rounded-full flex items-center justify-center mb-6 mx-auto text-[#3D4852]" data-id="element-165">
              <Moon className="w-8 h-8" data-id="element-166" />
            </div>
            <h3 className="text-xl font-bold text-[#3D4852] text-center mb-3" data-id="element-167">
              3. Rutina Anti-Antojos
            </h3>
            <p className="text-gray-600 text-center" data-id="element-168">
              Sueño, estrés, entorno. La noche manda sobre tu hambre del día
              siguiente.
            </p>
          </div>
        </div>
      </div>
    </section>;
}